<template>
    <div>
        <b-row class="mb-2">

            <b-col cols="2" class="d-flex justify-content-left mt-0 mb-3">

                <div class="p-1 pl-2 pr-1 d-flex justify-content-left rounded" style="background-color:#AAA;">
                    

                    <b-dropdown variant="info" split>
                        <template #button-content>
                            <b-form-checkbox :checked="allNotificationsSelected"
                                             :indeterminate="someNotificationsSelected"
                                             @change="checked => selectAllNotifications(checked)" />
                        </template>
                        <b-dropdown-item v-for="selectionFilter in availableSelectionFilters" :key="selectionFilter.code" @click="selectFilteredNotifications(selectionFilter)">{{ selectionFilter.displayName }}</b-dropdown-item>
                    </b-dropdown>
                    <b-dropdown id="bulkAction" text="Action" variant="info" size="md" class="ml-2" :disabled="availableBulkActions.length == 0">
                        <b-dropdown-item v-for="action in availableBulkActions" :key="action.intValue" @click="performBulkAction(action)">{{ action.displayName }}</b-dropdown-item>
                    </b-dropdown>

                </div>
            </b-col>

            <b-col cols="4">

                <b-input-group style="width: 100%;" size="lg"  class="pb-2">
                    <b-form-input type="text"
                                  placeholder="Search Subject"
                                  v-model="searchTerm"
                                  size="md"
                                 
                                  v-on:keyup.enter="retrieveNotifications" />
                    <b-input-group-append size="md">
                        <button class="btn btn-outline-secondary"
                                type="button"
                                @click="page = 1; retrieveNotifications();">
                            Search
                        </button>
                    </b-input-group-append>
                </b-input-group>
            </b-col>
            <b-col cols="5">
                <b-form-checkbox-group v-model="checkedEventSourceTypes"
                                       :options="allEventSourceTypes"
                                       size="lg"
                                       value-field="value"
                                       text-field="text"
                                       disabled-field="notEnabled"
                                       @change="retrieveNotifications">
                </b-form-checkbox-group>
            </b-col>

            <b-col cols="1">
                <b-button variant="success" size="md" class="w-100" @click="refreshList">REFRESH</b-button>
            </b-col>
        </b-row>

        <b-table :items="pagedItems"
                 v-if="pagedItems.length>0"
                 :fields="fields"
                 :sort-by.sync="sortBy"
                 :sort-desc.sync="sortDesc"
                 sort-icon-left
                 small
                 :tbody-tr-class="rowClass"
                 @sort-changed="sortChanged">

            <template #cell(selected)="data">

                <b-form-checkbox :checked="notificationSelected(data.item.id)"
                                 @change="checked => notificationSelectedChanged(data.item.id, checked)"
                                 size="sm"/>
            </template>

            <template #cell(subject)="data">
                <b-link active :href="notificationTargetUrl + '/' + data.item.id" target="_blank" class="subject">{{ data.item.subject }}</b-link>
            </template>

            <template #cell(createdDateTimeUTC)="data">
                {{ formatDateTime(data.item.createdDateTimeUTC, 'DD/MM/YYYY h:mmA', true, false) }}
            </template>

            <template #cell(targetDateTimeUTC)="data">
                {{ formatDateTime(data.item.targetDateTimeUTC, 'DD/MM/YYYY h:mmA', true, false) }}
            </template>

            <template #cell(actionDueDateTimeUTC)="data">
                {{ formatDateTime(data.item.actionDueDateTimeUTC, 'DD/MM/YYYY h:mmA', true, false) }}
            </template>

            <template #cell(actions)="data" sortable="false">
                <div class="d-flex justify-content-end align-items-center">
                    <span :class="'mr-3 mt-1 text-' + data.item.statusVariant" v-if="data.item.status">
                        <b-badge pill variant="data.item.statusVariant" class="border bg-white">{{ data.item.status }}</b-badge>
                    </span>
                    <b-button size="sm" :href="notificationTargetUrl + '/' + data.item.id + '/' + action.intValue" target="_blank" class="mr-1" :variant="action.variant" v-for="(action,actionIndex) in data.item.actions" :key="actionIndex">
                        {{ action.displayName }}
                    </b-button>
                    <b-button size="sm" variant="danger" :disabled="data.item.actions.length>0" @click="deleteNotification(data.item.id)" title="Delete">
                        <i class="fas fa-times"></i>
                    </b-button>
                </div>
            </template>
        </b-table>

        <b-row>
            <b-col cols="1">
                <b-select v-model="pageSize" @change="pageNr=1; retrieveNotifications()" :options="pageSizes" />
            </b-col>
            <b-col cols="6">
                <b-pagination v-model="pageNr"
                              :total-rows="totalRows"
                              :per-page="pageSize"
                              prev-text="Prev"
                              next-text="Next"
                              @change="handlePageChange">

                </b-pagination>
            </b-col>
            <b-col cols="5">
                <p style="font-size: 20px;float:right;">Total Notifications: {{ totalRows }}</p>
            </b-col>
        </b-row>

        <b-modal v-model="modalShow" title="Notification Actions" @ok="executeBulkAction">

            <strong>Action: </strong> {{ modalBulkAction.displayName }}
            <br />
            <strong>Nr of notifications affected: </strong> {{ selectedNotificationIds.length }}
            <br />  <br />
            <b-form-textarea id="textarea"
                             v-model="notificationMessage"
                             rows="3"
                             max-rows="6"
                             v-if="modalBulkAction.intValue >= 0"></b-form-textarea>
        </b-modal>

    </div>

</template>

<script>
    import Vue from 'vue';
    import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
    import axios from 'axios';
    import DateTimeMixin from '../mixins/DateTimeMixin';
    import InstallationAndVersionInfoMixins from '../mixins/InstallationAndVersionInfoMixins';
    Vue.use(BootstrapVue);
    Vue.use(BootstrapVueIcons);

    export default {
        name: "notification-list",
        mixins: [DateTimeMixin, InstallationAndVersionInfoMixins],
        props: {
            apiControllerUrl: {
                type: String,
                required: true
            },
            allEventSourceTypes: {
                type: Array,
                required: true
            },
            notificationTargetUrl: {
                type: String,
                required: true
            }
        },

        data() {
            return {
                availableSelectionFilters: [
                    {
                        code: 0,
                        displayName: this.$t('Vue.Notification.Shared.Deletable')
                    },
                    {
                        code: 1,
                        displayName: this.$t('Vue.Notification.Shared.Unseen')
                    },
                    {
                        code: 2,
                        displayName: this.$t('Vue.Notification.Shared.Actionable')
                    },
                ],
                selectedNotificationIds: [],

                modalShow: false,
                modalBulkAction: { intValue: -3, displayName: this.$t('Vue.Notification.Shared.NoActionSelected')},
                notificationMessage: null,

                searchTerm: '',
                showWorksheets: true,
                showOrders: true,
                requiresCount: true,
                checkedEventSourceTypes: [],
                sortBy: '',
                sortDesc: null,
                pageNr: 1,
                totalRows: 0,
                pageSize: 0,
                pageSizes: [5, 10, 25],
                pagedItems: [],
                fields: [
                    { key: 'selected', label: '', sortable: false, class: 'align-middle' },
                    { key: 'createdDateTimeUTC', label: 'Notification Date', sortable: true, class: 'align-middle' },
                    { key: 'subject', label: 'Subject', sortable: true, class: 'align-middle' },
                    { key: 'eventSourceAndCategories', label: 'Type', sortable: true, class: 'align-middle' },
                    { key: 'event', label: 'Event', sortable: true, class: 'align-middle' },
                    { key: 'targetDateTimeUTC', label: 'Item Due', sortable: true, class: 'align-middle' },
                    { key: 'actionDueDateTimeUTC', label: 'Action Due', sortable: true, class: 'align-middle' },
                    { key: 'daysUntilTarget', label: 'Days Till Due', sortable: true, class: 'align-middle' },
                    { key: 'actions', label: '', sortable: false }
                ]
            };
        },

        computed: {
            someNotificationsSelected: function () {
                return (this.pagedItems.length > 0) && (this.selectedNotificationIds.length > 0) && (this.selectedNotificationIds.length < this.pagedItems.length);
            },
            allNotificationsSelected: function () {
                return (this.pagedItems.length > 0) && (this.selectedNotificationIds.length == this.pagedItems.length);
            },
            availableBulkActions: function () {
                var deleteAction = {
                    intValue: -2,
                    displayName: this.$t('Vue.Notification.Shared.Delete')
                };
                var markSeenAction = {
                    intValue: -1,
                    displayName: this.$t('Vue.Notification.Shared.MarkSeen')
                };
                var actions = [];
                var first = true;
                this.selectedNotificationIds.forEach(notificationId => {
                    var notification = this.pagedItems.find(n => n.id == notificationId);
                    if (notification) {
                        var possibleActions = [];
                        if (!notification.seen) {
                            possibleActions.push(markSeenAction);
                        }
                        if (notification.actions.length == 0) {
                            possibleActions.push(deleteAction);
                        } else {
                            notification.actions.forEach(action => {
                                possibleActions.push({ intValue: action.intValue, displayName: action.displayName });
                            });
                        }
                        if (first) {
                            possibleActions.forEach(action => {
                                actions.push(action);
                            });
                        } else {
                            var i = 0;
                            while (i < actions.length) {
                                if (possibleActions.findIndex(action => action.intValue == actions[i].intValue) < 0) {
                                    actions.splice(i, 1);
                                } else {
                                    i++;
                                }
                            }
                        }
                        first = false;
                    }
                });
                return actions;
            }
        },
        methods: {
            notificationSelected: function (notificationId) {
                return this.selectedNotificationIds.indexOf(notificationId) >= 0;
            },

            selectAllNotifications: function (checked) {
                var newSelectedNotificationIds = [];
                if (checked) {
                    this.pagedItems.forEach(notification => {
                        newSelectedNotificationIds.push(notification.id);
                    });
                }
                this.selectedNotificationIds = newSelectedNotificationIds;
            },

            selectFilteredNotifications: function (selectionFilter) {
                var newSelectedNotificationIds = [];
                this.pagedItems.forEach(notification => {
                    if (selectionFilter.code == 0) { //deletable
                        if (notification.actions.length == 0) newSelectedNotificationIds.push(notification.id);
                    } else if (selectionFilter.code == 1) { //unseen
                        if (!notification.seen) newSelectedNotificationIds.push(notification.id);
                    } else if (selectionFilter.code == 2) { //actionable
                        if (notification.actions.length > 0) newSelectedNotificationIds.push(notification.id);
                    }
                });
                this.selectedNotificationIds = newSelectedNotificationIds;
            },
            
            // little checkbox at start of single notification line
            notificationSelectedChanged: function (notificationId, selected) {

                if (selected) {
                    this.selectedNotificationIds.push(notificationId);
                } else {
                    const index = this.selectedNotificationIds.indexOf(notificationId);
                    if (index > -1) { // only splice array when item is found
                        this.selectedNotificationIds.splice(index, 1); // 2nd parameter means remove one item only
                    }
                }
            },
                      
            performBulkAction: function (bulkAction) {
                this.modalBulkAction = bulkAction;
                this.notificationMessage = null;
                this.modalShow = true;
            },

            executeBulkAction: function () {
                var data = null;
                var url = null;

                // since the bulk delte operation is imlemented a bit differently we have to reroute
                if (this.modalBulkAction.intValue == -2) { //delete
                    data = this.selectedNotificationIds;
                    url = this.apiControllerUrl + '/bulkdismiss';
                } else if (this.modalBulkAction.intValue == -1) { //mark seen
                    data = this.selectedNotificationIds;
                    url = this.apiControllerUrl + '/bulkseen';
                } else {
                    data = {
                        action: this.modalBulkAction.intValue,
                        comment: this.notificationMessage,
                        notificationIds: this.selectedNotificationIds
                    }
                    url = this.apiControllerUrl + '/bulkaction';
                }
                if (url && data) {
                    axios
                        .post(url, JSON.stringify(data),
                            {
                                headers: {
                                    'Content-Type': 'application/json'
                                }
                            })
                        .then(response => {
                            var responseVariant = 'danger'
                            var operationResult = response.data[0].success;
                            if (operationResult) responseVariant = 'success';

                            this.$bvToast.toast(response.data[0].message, {
                                title: 'Bulk action: ' + this.modalBulkAction.displayName,
                                variant: responseVariant,
                                appendToast: true
                            });

                            this.refreshList();
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }
            },

            retrieveNotifications() {

                var currentOptions = {
                    pageSize: this.pageSize,
                    sortBy: this.sortBy,
                    sortDesc: this.sortDesc
                }
                localStorage.setItem(this.addTopsInstallationAndVersionPrefix('notificationList'), JSON.stringify(currentOptions));

                const httpRequestParameter = {
                    searchTerm: this.searchTerm,
                    pageNr: this.pageNr,
                    pageSize: this.pageSize,
                    sortBy: this.sortBy,
                    sortDescending: this.sortDesc,
                    IncludeSources: this.checkedEventSourceTypes,
                    RequiresCount: this.requiresCount
                }

                var url = this.apiControllerUrl + '/list';
                return axios
                    .post(url, JSON.stringify(httpRequestParameter),
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                    .then(response => {

                        this.pagedItems = response.data.notifications;
                        this.selectedNotificationIds = [];
                        this.totalRows = response.data.count;
                        this.requiresCount = true;
                        this.allDone = true;
                    })

                    .catch(function (error) {
                        console.log(error);
                    });
            },

            rowClass(item, type) {
                if (!item || type !== 'row') return;
                var colorClass = '';
               
                if (item.daysUntilTarget == 0) colorClass = 'notification-today';
                if (item.daysUntilTarget < 0) colorClass = 'notification-overdue';
                if (this.notificationSelected(item.id)) {
                    if (colorClass != '') colorClass += ' ';
                    colorClass += 'notification-marked-for-bulkoperation';
                }
                
                return colorClass;
            },

            handlePageChange(newPage) {                
                this.pageNr = newPage;
                this.retrieveNotifications();
            },

            sortChanged(ctx) {
                this.sortDesc = ctx.sortDesc;
                this.sortBy = ctx.sortBy;
                this.retrieveNotifications();
            },

            deleteNotification(notificationId) {

                var url = this.apiControllerUrl + '/' + notificationId;
                return axios
                    .delete(url)
                    .then(() => {
                        this.refreshList();
                        this.$bvToast.toast('Notification deleted successfully', {
                            title: 'Notification deleted',
                            variant: 'success',
                            appendToast: true
                        });
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            refreshList() {
                this.requiresCount = true;
                this.retrieveNotifications();
            },

        },
        mounted() {
            var currentOptionsString = localStorage.getItem(this.addTopsInstallationAndVersionPrefix('notificationList'));
            if (currentOptionsString) {
                var currentOptions = JSON.parse(currentOptionsString);
                this.pageSize = currentOptions.pageSize;
                this.sortBy = currentOptions.sortBy;
                this.sortDesc = currentOptions.sortDesc;
            } else {
                this.pageSize = 10;
                this.sortBy = 'createdDateTimeUTC';
                this.sortDesc = true;
            }

            this.allEventSourceTypes.forEach((est) => {
                this.checkedEventSourceTypes.push(est.value);
            });
            this.retrieveNotifications();
        }
    };
</script>

<style scoped>
    >>> .notification-overdue {
        background-color: #F5C6CB !important;
    }
    >>> .notification-today {
        background-color: #FFEEBA !important;
    }
    >>> .notification-marked-for-bulkoperation {
        background-color: #FFEEAA !important;
    }

    .table-header-size {
        font-size:24px;
    }
    a.subject:link {
        color: blue;
        font-weight: bold;
    }
    a.subject:visited {
        color: blue;
        font-weight: normal;
    }
    a.subject:hover {
        color: orange;
        font-weight: bold;
    }
</style>


